import { styled } from "../../../styled-components";

export const BigLabel = styled.div`
    ${p => p.theme.fontStyles.AccentHeader4};
    color: ${p => p.theme.fgColorDark};
`;

export const BigLabelContainer = styled.div`
    padding: 0 ${p => p.theme.pageMarginMedium}px ${p => p.theme.componentSmallInnerVerticalPadding}px;
    display: flex;
    justify-content: space-between;
`;
